Object.defineProperty (module.exports, "__esModule", { value: true }),
module.exports.DateTimeNameStyle = module.exports.default = {
	FULL: "full",
	LONG_ABBREVIATION: "longAbbreviation",
	SHORT_ABBREVIATION: "shortAbbreviation",
};